<template>
  <div>
    <Head title="Permissions" />
    <h1 class="mb-8 text-2xl font-bold">Data Permission</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link v-if="can('write permission')" class="btn-indigo" href="/permissions/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
        <span class="hidden md:inline">&nbsp;Permission</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Nama Permission</th>
          <th class="pb-4 pt-6 px-6">Guard Name</th>
          <th class="pb-4 pt-6 px-6">Aksi</th>
        </tr>
        <tr v-for="permission in permissions.data" :key="permission.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ permission.name }}
            </div>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4">
              {{ permission.guard_name }}
            </div>
          </td>
          <td v-if="can('write permission')" class="p-4 w-px border-t">
            <Link class="btn-indigo-sm rounded-l" :href="`/permissions/${permission.id}/edit`">
              <font-awesome-icon icon="fas fa-pencil" />
            </Link>
            <Link class="btn-red-sm rounded-r" @click.prevent="destroy(permission.id)">
              <font-awesome-icon icon="fas fa-trash" />
            </Link>
          </td>
        </tr>
        <tr v-if="permissions.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="3">Data Permission tidak ada.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="permissions.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    permissions: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/permissions', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/permissions/${id}`)
        }
      })
    },
  },
}
</script>
